import React from 'react';

import { Accordion, AccordionItem, AccordionItemProps, AccordionProps } from 'components/common/MelodyAccordion';

import css from 'styles/components/landing/landingPageAccordion.scss';

export const LandingPageAccordionItem = (props: AccordionItemProps) => (
  <AccordionItem {...props} accordionRegionContainerStyleOverride={css.landingPageAccordionItem} />
);

export const LandingPageAccordion = (props: AccordionProps) => {
  const { children } = props;
  return <Accordion {...props}>{children}</Accordion>;
};
